import { pageMeta } from '../seo.js';
import { Link } from 'react-router';
import ListView from '../components/ListView.jsx';
import { loadList } from '../data/list.js';
import { DateCell } from '../components/ui.jsx';
import { currentAddress } from '../data/entity.js';

const FIELDS = ['name', 'enhedsNummer', 'beliggenhedsadresse', 'sidstOpdateret'];

const COLUMNS = [
  { key: 'name', label: 'Name', render: (p) => <Link to={`/Person/${p.enhedsNummer}`}>{p.name}</Link> },
  { key: 'enhedsNummer', label: 'Enhedsnummer', numeric: true },
  { key: 'address', label: 'Address', render: (p) => currentAddress(p.beliggenhedsadresse) || <span className="muted">—</span> },
  { key: 'sidstOpdateret', label: 'Opdateret', sortField: 'sidstOpdateret', render: (p) => <DateCell value={p.sidstOpdateret} /> },
];

const LIST = { kind: 'person', from: 'cvrperson', fields: FIELDS };

// The server gets the rows before it sends the page (data/list.js).
export const loader = ({ request }) => loadList(new URL(request.url), LIST);

export const meta = () => pageMeta({
  title: 'People – CVR register',
  description: 'Search the persons who take part in a Danish company in the CVR register.',
  path: '/People',
});

export default function PeoplePage() {
  return (
    <ListView
      title="People"
      subtitle="The persons who take part in a company"
      columns={COLUMNS}
      placeholder="Name, enhedsnummer or JSON query"
      hint="A name search matches whole words."
    />
  );
}
